import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useParams, useNavigate } from "react-router-dom";

import { GetSingleUserDiscount, reset } from "../../../features/UserDiscountSlice";

import {
  Card,
  Button,
  Form,
  Col,
  Row,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronCircleLeft,
  faPencilAlt,
} from "@fortawesome/free-solid-svg-icons";

import AdminLayout from "../../../layout/admin";
import { Header } from "../../../components/admin";

import {
  hideLoadingDialog,
  showAlertDialog,
  showFailedDialog,
  showLoadingDialog,
  showSuccessDialog,
} from "../../../helpers/dialog.helper";

import BASE_URL from "../../../api";
import Select from 'react-select';
import { formatNumber, removeFormatter, removeTrailingZero } from "../../../helpers/helper";

const FormData = () => {
  const [dataListKodePay, setDataListKodePay] = useState([]);
  const [newData, setNewData] = useState({
    nama: "",
    menus: "",
  });

  const dispatch = useDispatch();
  const { data, isLoading, isError } = useSelector((state) => state.userDiscount);

  const param = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const token = localStorage.getItem("token");

  useEffect(() => {
    dispatch(reset());

    // fetch data.
    if (id) {
      fetchData();
    }
  }, [id, dispatch, token]);

  function fetchData() {
    dispatch(reset());
    dispatch(GetSingleUserDiscount({ id, token }));
  }

  useEffect(() => {
    setNewData({
      nim: data?.data?.nim,
      kode_pay: data?.data?.kode_pay,
      percentage: data?.data?.percentage,
      discount_amt: data?.data?.discount_amt,
      discount_amtMask: removeTrailingZero(data?.data?.discount_amt),
    });
  }, [data]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    const getAllResource = async () => {
      try {
        const kodePayResponse = await axios.get(`${BASE_URL}master/kode_payment`, {
          headers: {
            Authorization: token,
          },
          cancelToken: source.token,
        });
        const kodePayFormated = kodePayResponse.data.data.map((kodePay) => ({
          value: kodePay,
          label: `[${kodePay.kode}]/[${kodePay.periode_mulai}] - ${kodePay.deskripsi}`,
        }));
        setDataListKodePay(kodePayFormated);
      } catch (error) {}
    };

    getAllResource();
    return () => {
      source.cancel("Komponen dibongkar, membatalkan permintaan.");
    };
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    showAlertDialog({
      title: id ? "Update?" : "Simpan?",
      msg: `apakah anda yakin ingin ${
        id ? "mengupdate" : "menyimpan"
      } data ini?`,
      confirmButtonText: id ? "Update" : "Simpan",
      onConfirm: async () => {
        showLoadingDialog();
        try {
          let response;
          if (id) {
            response = await axios.put(
              `${BASE_URL}master/user_discount/${id}`,
              {
                ...newData,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          } else {
            response = await axios.post(
              `${BASE_URL}master/user_discount`,
              {
                ...newData,
              },
              {
                headers: {
                  Authorization: token,
                },
              }
            );
          }
          console.log("RESPONSE : ", response);
          hideLoadingDialog();
          showSuccessDialog({
            title: "Berhasil!",
            msg: "Berhasil menyimpan data!",
          });
          navigate("/master/user-discount/list");
        } catch (error) {
          console.log("ERROR", error);
          hideLoadingDialog();
          showFailedDialog({
            title: "Oops!",
            msg: error?.response?.data?.message || "Gagal menyimpan data!",
          });
        }
      },
    });
  };

  return (
    <AdminLayout>
      {param.pathname.split("/")[3] === "view" ? (
        <>
          <Header
            title="Detail User Discount"
          >
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/user-discount/edit/${id}`}
            >
            <FontAwesomeIcon icon={faPencilAlt} className="me-2" />
              Edit
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "add" ? (
        <>
          <Header
            title="Tambah User Discount"
          >
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/user-discount/list`}
            >
            <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : param.pathname.split("/")[3] === "edit" ? (
        <>
          <Header
            title="Edit User Discount"
          >
            <Button
              variant="outline-primary"
              size="sm"
              href={`/master/user-discount/list`}
            >
            <FontAwesomeIcon icon={faChevronCircleLeft} className="me-2" />
              Kembali
            </Button>
          </Header>
        </>
      ) : null}
      <Card border="light" className="shadow-sm mb-4">
        <FormPage
          id={id}
          newData={newData}
          setNewData={setNewData}
          isLoading={isLoading}
          dataListKodePay={dataListKodePay}
          isLocked={param.pathname.split("/")[3] === "view" || isLoading}
          handleSubmit={handleSubmit}
        />
      </Card>
    </AdminLayout>
  );
};

const FormPage = ({
  newData,
  setNewData,
  id,
  isLocked = false,
  isLoading = false,
  dataListKodePay,
  handleSubmit,
}) => {
  return (
    <Card.Body>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={12} className="mb-3">
              <Form.Group id="nim_user_discount">
                <Form.Label>NIM</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="NIM"
                  name="nim_user_discount"
                  disabled={isLocked}
                  value={newData.nim || ""}
                  onChange={(e) =>
                    setNewData({ ...newData, nim: e.target.value })
                  }
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="kode_pay_user_discount">
                <Form.Label>Kode Pembayaran</Form.Label>
                <Select
                  options={dataListKodePay}
                  placeholder="Pilih kode pembayaran"
                  isDisabled={isLocked}
                  value={dataListKodePay?.find(e => e.value.kode === newData.kode_pay)}
                  onChange={(e) => {
                    const nominal = e.value.nominal;
                    const total = ((newData.percentage || 0)/100)*nominal;
                    setNewData({
                      ...newData,
                      kode_pay: e.value.kode,
                      discount_amt: total,
                      discount_amtMask: formatNumber(total),
                    });
                  }}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="percentage">
                <Form.Label>Persentase Diskon</Form.Label>
                <InputGroup>
                  <Form.Control
                    required
                    type="number"
                    min={0}
                    max={100}
                    placeholder="0"
                    name="percentage"
                    disabled={isLocked}
                    value={newData.percentage || ""}
                    onChange={(e) => {
                      const persen = e.target.value;
                      if (newData?.kode_pay) {
                        const payData = dataListKodePay?.find(e => e.value.kode === newData.kode_pay);
                        if (payData) {
                          const nominal = payData.value.nominal;
                          const total = ((persen || 0)/100)*nominal;
                          setNewData({
                            ...newData,
                            percentage: persen,
                            discount_amt: total,
                            discount_amtMask: formatNumber(total),
                          })
                        }
                      } else {
                        setNewData({
                          ...newData,
                          percentage: persen,
                        })
                      }
                    }}
                  />
                  <InputGroup.Text>%</InputGroup.Text>
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={12} className="mb-3">
              <Form.Group id="discount_amt">
                <Form.Label>Nominal Diskon</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="0"
                  name="discount_amt"
                  disabled={true}
                  value={newData.discount_amtMask || ""}
                  onChange={(e) =>
                    setNewData({
                      ...newData,
                      discount_amt: removeFormatter(e.target.value),
                      discount_amtMask: formatNumber(e.target.value),
                    })
                  }
                />
              </Form.Group>
            </Col>
          </Row>
          <div>
            {!isLocked ? (
              <Button type="submit">{id ? "Update" : "Simpan"}</Button>
            ) : null}
          </div>
        </Form>
      )}
    </Card.Body>
  );
};

export default FormData;
